export const getOpenChatConversationCount = state => state.chat.openChatConversationsCount;
